import * as ACTIONTYPE from '../constants/actiontypes'
// import { isMobile } from "react-device-detect";

const initialVideoPlayerState = {
  PLAYER: null,
  isReady: false,
  isFullscreen: false,
  isPlaying: false,
  needsSound: false,
  isStarted: false,
  isBellEnabled: false,
  bellHintVisibility: false,
  subtitlesVisibility: true,
  realDuration: -1,
  volume: 1,
  currentTime: 0,
  autoplay: false,
  waitingForAction: false,
  alreadyLogged: false,
};

export default function (state = initialVideoPlayerState, action) {
  switch (action.type) {
    case ACTIONTYPE.VIDEO_PLAYER_IS_READY:
      return {
        ...state,
        isReady: action.data
      };
    case ACTIONTYPE.VIDEO_PLAYER_STARTED:
      const { isStarted } = action;
      return {
        ...state,
        isStarted
      };

    case ACTIONTYPE.SET_AUTOPLAY:
      const { autoplay } = action;
      return {
        ...state,
        autoplay
      };
    case ACTIONTYPE.CHANGE_PLAY_MODE:
      const { isPlaying } = action;
      return {
        ...state,
        isPlaying
      };
    case ACTIONTYPE.TOGGLE_FULL_SCREEN:
      return {
        ...state,
        isFullscreen: action.isActive
      };
    case ACTIONTYPE.INIT_REAL_DURATION:
      return {
        ...state,
        realDuration: action.duration
      };
    case ACTIONTYPE.CURRENT_TIME_CHANGE:
      const { currentTime } = action;
      return {
        ...state,
        currentTime
      };
    case ACTIONTYPE.SAVE_PLAYER:
      const { PLAYER } = action;
      return {
        ...state,
        PLAYER
      };
    case ACTIONTYPE.SET_VOLUME:
      const { volume } = action;
      return {
        ...state,
        volume
      };
    case ACTIONTYPE.TOGGLE_SUBTITLES_VISIBILITY:
      return {
        ...state,
        subtitlesVisibility: !state.subtitlesVisibility
      };
    case ACTIONTYPE.TOGGLE_BELL_PLAY:
      return {
        ...state,
        isBellEnabled: !state.isBellEnabled,
        bellHintVisibility: !state.bellHintVisibility,
      };
    case ACTIONTYPE.TOGGLE_BELL_HINT:
      return {
        ...state,
        bellHintVisibility: !state.bellHintVisibility,
      };
    case ACTIONTYPE.SET_WAITING_FOR_ACTION:
      return {
        ...state,
        waitingForAction: action.data,
      };

    case ACTIONTYPE.ALREADY_LOGGED:
      return {
        ...state,
        alreadyLogged: true,
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/VideoPlayerReducer.js